import React from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

const similarGames = [
{
  id: 'similar-001',
  title: 'Pixel Dungeon',
  category: 'RPG',
  plays: 7640,
  likes: 403,
  author: 'rpg_master',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1ef366281-1772244461834.png",
  thumbnailAlt: 'Pixel art dungeon RPG with torches and stone corridors',
  model: 'Advanced'
},
{
  id: 'similar-002',
  title: 'Space Adventure',
  category: 'Aventura',
  plays: 3560,
  likes: 145,
  author: 'space_explorer',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_18b3de152-1772293390326.png",
  thumbnailAlt: 'Space adventure game with planets and stars',
  model: 'Pro'
},
{
  id: 'similar-003',
  title: 'Ninja Shadows',
  category: 'Ação',
  plays: 5820,
  likes: 276,
  author: 'shadow_coder',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1fabd4f73-1772340073613.png",
  thumbnailAlt: 'Ninja action game with dark shadows and Japanese aesthetic',
  model: 'Pro'
},
{
  id: 'similar-004',
  title: 'Tower Defense Z',
  category: 'Estratégia',
  plays: 9240,
  likes: 512,
  author: 'strategy_pro',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1f8a20e3e-1772565716449.png",
  thumbnailAlt: 'Tower defense strategy game with colorful towers',
  model: 'Advanced'
}];


export default function SimilarGames({ currentGameId }: {currentGameId: string;}) {
  const games = similarGames.filter((g) => g.id !== currentGameId);

  return (
    <div className="mt-12">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-bold text-foreground">Jogos semelhantes</h2>
        <Link href="/explore" className="text-xs text-primary hover:text-primary/80 transition-colors flex items-center gap-1">
          Ver todos
          <Icon name="ArrowRightIcon" size={12} />
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {games.map((game) =>
        <Link
          key={game.id}
          href="/game-public-page"
          className="group block rounded-2xl overflow-hidden bg-card border border-border hover:border-primary/30 transition-all duration-200 glow-card">
          
            <div className="relative aspect-video overflow-hidden">
              <AppImage
              src={game.thumbnail}
              alt={game.thumbnailAlt}
              fill
              sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
              className="object-cover group-hover:scale-105 transition-transform duration-300" />
            
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute top-2 left-2">
                <span className={`
                  text-xs font-semibold px-2 py-0.5 rounded-full
                  ${game.model === 'Free' ? 'bg-success/20 text-success' :
              game.model === 'Pro' ? 'bg-primary/20 text-primary' : 'bg-accent/20 text-accent'}
                `}>
                  {game.model}
                </span>
              </div>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-10 h-10 rounded-full gradient-primary flex items-center justify-center">
                  <Icon name="PlayIcon" size={16} className="text-white ml-0.5" variant="solid" />
                </div>
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-semibold text-foreground text-sm truncate mb-1">{game.title}</h3>
              <p className="text-xs text-muted-foreground mb-2">@{game.author} · {game.category}</p>
              <div className="flex items-center gap-3 text-xs text-muted-foreground">
                <span className="flex items-center gap-1">
                  <Icon name="PlayIcon" size={11} />
                  {game.plays.toLocaleString('pt-PT')}
                </span>
                <span className="flex items-center gap-1">
                  <Icon name="HeartIcon" size={11} />
                  {game.likes}
                </span>
              </div>
            </div>
          </Link>
        )}
      </div>
    </div>);

}